/* eslint-disable no-case-declarations */
/* eslint-disable no-plusplus */
/* eslint-disable prefer-const */
/* eslint-disable default-case */
/* eslint-disable no-unused-vars */
/* eslint-disable guard-for-in */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-use-before-define */

function useObjectDiff() {
  let openChar = '{';
  let closeChar = '}';

  function diff(a, b, shallow, isOwn) {
    if (a === b) {
      return equalObj(a);
    }

    const diffValue = {};
    let equal = true;

    for (const key in a) {
      if ((!isOwn && key in b) || (isOwn && typeof b !== 'undefined' && b.hasOwnProperty(key))) {
        if (
          key === 'appIconUrl' ||
          key === 'pageIndex' ||
          key === 'options' ||
          key === 'enableFixedView' ||
          key === 'code' ||
          key === 'added' ||
          key === 'removed' ||
          key === 'isFromScriptLogic'
        ) {
          // Skip comparison for appIconUrl key
          break;
        }
        if (a[key] === b[key]) {
          diffValue[key] = equalObj(a[key]);
        } else if (!shallow && isValidAttr(a[key], b[key])) {
          const valueDiff = diff(a[key], b[key], shallow, isOwn);
          if (valueDiff.changed === 'equal') {
            diffValue[key] = equalObj(a[key]);
          } else {
            equal = false;
            diffValue[key] = valueDiff;
          }
        } else {
          equal = false;
          diffValue[key] = {
            changed: 'primitive change',
            removed: a[key],
            added: b[key],
          };
        }
      }
      // else {
      //     equal = false;
      //     diffValue[key] = {
      //         changed: 'removed',
      //         value: a[key]
      //     };
      // }
    }

    // for (const key in b) {
    //     if ((!isOwn && !(key in a)) || (isOwn && typeof a !== 'undefined' && !a.hasOwnProperty(key))) {
    //         equal = false;
    //         diffValue[key] = {
    //             changed: 'added',
    //             value: b[key]
    //         };
    //     }
    // }

    if (equal) {
      return equalObj(a);
    }
    return {
      changed: 'object change',
      value: diffValue,
    };
  }

  function diffOwnProperties(a, b, shallow) {
    return diff(a, b, shallow, true);
  }

  function formatToJsonXMLString(changes, shallow) {
    const properties = [];

    const diff = changes.value;
    if (changes.changed === 'equal') {
      // Return formatted HTML for equal changes
    }

    for (const key in diff) {
      properties.push(formatChange(key, diff[key], shallow));
    }

    // Return formatted HTML for non-equal changes
  }

  function formatObjToJsonXMLString(obj, shallow) {
    // Return formatted HTML for object to JSON/XML conversion
  }

  function formatChangesToXMLString(changes, shallow) {
    const properties = [];

    if (changes.changed === 'equal') {
      // Return empty string for equal changes
    }

    const diff = changes.value;

    for (const key in diff) {
      const { changed } = diff[key];
      if (changed !== 'equal') {
        properties.push(formatChange(key, diff[key], shallow, true));
      }
    }

    // Return formatted HTML for non-equal changes
  }

  function equalObj(obj) {
    return {
      changed: 'equal',
      value: obj,
    };
  }

  function isValidAttr(a, b) {
    const typeA = typeof a;
    const typeB = typeof b;
    return a && b && (typeA === 'object' || typeA === 'function') && (typeB === 'object' || typeB === 'function');
  }

  function formatChange(key, diffItem, shallow, diffOnly) {
    const { changed } = diffItem;
    let property;
    switch (changed) {
      case 'equal':
        // Return formatted HTML for equal changes
        break;

      case 'removed':
        // Return formatted HTML for removed changes
        break;

      case 'added':
        // Return formatted HTML for added changes
        break;

      case 'primitive change':
        // Return formatted HTML for primitive changes
        break;

      case 'object change':
        property = shallow
          ? ''
          : `${stringifyObjectKey(key)}: ${
              diffOnly ? formatChangesToXMLString(diffItem) : formatToJsonXMLString(diffItem)
            }`;
        break;
    }

    return property;
  }

  function stringifyObjectKey(key) {
    return /^[a-z0-9_$]*$/i.test(key) ? key : JSON.stringify(key);
  }

  function escapeHTML(string) {
    return string.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function inspect(obj, shallow) {
    return _inspect('', obj, shallow);

    // eslint-disable-next-line no-underscore-dangle
    function _inspect(accumulator, obj, shallow) {
      switch (typeof obj) {
        case 'object':
          if (!obj) {
            accumulator += 'null';
            break;
          }
          if (shallow) {
            accumulator += '[object]';
            break;
          }
          // eslint-disable-next-line no-case-declarations
          const keys = Object.keys(obj);
          const { length } = keys;
          if (length === 0) {
            accumulator += openChar + closeChar;
          } else {
            accumulator += `${openChar}\n`;
            for (let i = 0; i < length; i++) {
              const key = keys[i];
              accumulator = _inspect(`${accumulator + stringifyObjectKey(escapeHTML(key))}: `, obj[key]);
              if (i < length - 1) {
                accumulator += ',\n';
              }
            }
            accumulator += `\n${closeChar}`;
          }
          break;

        case 'string':
          accumulator += JSON.stringify(escapeHTML(obj));
          break;

        case 'undefined':
          accumulator += 'undefined';
          break;

        default:
          accumulator += escapeHTML(String(obj));
          break;
      }
      return accumulator;
    }
  }

  return {
    diff,
    diffOwnProperties,
    formatToJsonXMLString,
    formatObjToJsonXMLString,
    formatChangesToXMLString,
    equalObj,
    isValidAttr,
    formatChange,
    stringifyObjectKey,
    escapeHTML,
    inspect,
  };
}

export default useObjectDiff;
